<app-user-search-input (searchResult)="searchResult = $event" (searching)="searching = $event"
                       [additionalFilter]="additionalFilter"></app-user-search-input>
<app-user-search-output (selected)="onUserChoosed($event)" [searchResult]="searchResult"
                        [searching]="searching"></app-user-search-output>
